import { render, staticRenderFns } from "./table-box.vue?vue&type=template&id=2927af56&scoped=true"
import script from "./table-box.vue?vue&type=script&lang=js"
export * from "./table-box.vue?vue&type=script&lang=js"
import style0 from "./table-box.vue?vue&type=style&index=0&id=2927af56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927af56",
  null
  
)

export default component.exports